<template>
  <section class="payment-schedule-section">
    <div
      v-for="(schedule, index) in paymentSchedule"
      :key="`schedule-${index}`"
      class="payment-schedule-section__schedule"
    >
      <h4 class="payment-schedule-section__schedule-title">
        <span v-if="schedule.title">{{ schedule.title }}</span>
        <small v-if="schedule.period">({{ schedule.period }})</small>
      </h4>
      <p
        v-if="schedule.price"
        class="payment-schedule-section__schedule-price"
        v-text="schedule.price"
      />
      <p
        v-if="schedule.description"
        class="payment-schedule-section__schedule-description"
        v-text="schedule.description"
      />
      <p
        v-if="schedule.note"
        class="payment-schedule-section__schedule-note"
        v-text="schedule.note"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'

export type PaymentScheduleData = {
  title: string | null
  period: string | null
  price: string | null
  description: string | null
  note: string | null
  // 請求0円の場合に表示対象外とするかを判定するために使用する
  priceNum?: number
  /**
   * 決済日時 UnixTime(ミリ秒)
   * 請求予定ソート用に使用
   */
  settlementDateNum?: number
}

/**
 * 契約導線: 支払予定 セクション
 */
export default defineComponent({
  name: 'PaymentScheduleSection',
  props: {
    /**
     * 請求予定情報
     */
    paymentSchedule: {
      type: Array as PropType<PaymentScheduleData[]>,
      default: null,
    },
  },
})
</script>

<style lang="scss" scoped>
.payment-schedule-section {
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  padding: 6px 16px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 6px;
  border: 1px solid $black10;

  &__schedule {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 3px;
    width: 100%;
    padding: 10px 0;
    font-family: $fontSignup;
    color: $gray50;
    font-weight: 500;
    text-align: left;

    &:not(:first-child) {
      border-top: 1px solid $black10;
      padding-top: 11px;
    }

    &-title {
      @include fontSetTextMedium();

      small {
        font-size: 12px;
        line-height: 1.66;
      }
    }

    &-price {
      margin-top: 1px;
      color: $gray75;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.43;
    }

    &-description {
      color: var(--gray-75, #4e4e4e);
      font-size: 12px;
      line-height: 1.66;
    }

    &-note {
      font-size: 11px;
      line-height: 1.27;
    }
  }
}
</style>
